import React from 'react'

export default function Footer() {
  return (
    <div>



<footer className="footer footer-center mt-6  w-full p-4 bg-black border border-solid border-gray-600 text-white">
      <div className="text-center">
        <p>
          Designed and Developed by 
          <a className="font-semibold ml-1 mr-1" href="jihadfed95@gmail.com">Jihad.</a>
          2022
        </p>
      </div>
    </footer>


    </div>
  )
}
